import React from 'react';
import MainLayout from 'components/layout/MainLayout';
import StayInTheLoopSection from 'components/landing/StayInLoopSection';
import BlogArticleCard from 'components/blog/BlogArticleCard';
import { NextSeo } from 'next-seo';
import { BLOG_ARTICLES } from 'constants/Blogs';
import PageTitle from 'components/PageTitle';

const Blog = () => {
  return (
    <MainLayout>
      <NextSeo
        title='Our Blog | Win Epic Prizes | DAYMADE'
        description="Check out our blog for all things DAYMADE! Essential travel tips, tricks, updates, highlights and lists (everybody loves a good list)"
        openGraph={{
          title: 'Our Blog | Win Epic Prizes | DAYMADE',
          description: "Check out our blog for all things DAYMADE! Essential travel tips, tricks, updates, highlights and lists (everybody loves a good list)",
        }}
      />

      <PageTitle>
        Our <strong>Blog</strong>
      </PageTitle>

      <div className="blogArticles">
        { BLOG_ARTICLES.map(article => (
          <BlogArticleCard
            key={article.href}
            title={article.title}
            subheading={article.subheading}
            datePostedString={article.datePostedString}
            imageDirectory={article.imageDirectory}
            href={article.href}
            backgroundPosition={article.backgroundPosition}
          />
        ))}
      </div>

      <StayInTheLoopSection />

      <style jsx>{`
        .blogArticles {
          display: grid;
          grid-template-columns: 1fr;
          grid-gap: 1.5em;
          max-width: 700px;
          padding: 2em 1em;
        }
      `}</style>
    </MainLayout>
  );
};

export default Blog;
